export default __webpack_public_path__ + "static/media/Desenvolvimento-Mobile-PT.d1b8512e.jpg";